export default "__VITE_ASSET__BkFjnQyF__"